class CommonUtils {
    static removeDotSegments(input) {
        var output = [];
        function handleDotSegments(p) {
            if (p === '/..') {
                output.pop();
            }
            else {
                output.push(p);
            }
        }
        input.replace(/^(\.\.?(\/|$))+/, '')
            .replace(/\/(\.(\/|$))+/g, '/')
            .replace(/\/\.\.$/, '/../')
            .replace(/\/?[^/]*/g, handleDotSegments);
        return output.join('').replace(/^\//, input.charAt(0) === '/' ? '/' : '');
    }
    /**
     * Build an url from linkHref param in same context than widgetUrl param.
     *
     * @example
     * CommonUtils.Utils.buildUrl("http://example.org/mywidget.html", "/index.html");
     * // will return "http://example.org/index.html"
     *
     * @param {String} url - A full absolute url (e.g "http://example.org")
     * @param {String} href - Another url or simple file path (e.g. "/index.html")
     * @return {String} A new url related to widgetUrl url absolute value.
     *
     * @alias CommonUtils.Utils.buildUrl
     */
    static buildUrl(url, href) {
        var defaultScheme = (window.location && window.location.protocol ? window.location.protocol : 'http:');
        // Cast to string to handle window.location for example.
        url = String(url);
        href = String(href);
        if (!CommonUtils.isAbsoluteUrl(url)) {
            throw new Error('First argument should be a absolute url.');
        }
        // protocol less support
        if (url.substring(0, 2) === '//') {
            url = defaultScheme + url;
        }
        var i, l, splitScheme = String(url).split('://'), scheme = splitScheme[0], resource = splitScheme[1], splitDirectory = resource.split('/'), domain = splitDirectory[0], path = '';
        // protocol less
        if (href.substring(0, 2) === '//') {
            url = scheme + ':' + href;
            // complete
        }
        else if (href.split('://').length > 1) {
            url = href;
            // absolute
        }
        else if (href.substring(0, 1) === '/') {
            url = scheme + '://' + domain + href;
            // relative
        }
        else {
            for (i = 1, l = splitDirectory.length - 1; i < l; i++) {
                path += '/' + splitDirectory[i];
            }
            url = scheme + '://' + domain + CommonUtils.removeDotSegments(path + '/' + href);
        }
        return url;
    }
    /**
     * Parse an Url to extract uri parts (protocol, domain, ...). The URL should include the protocol (http://).
     *
     * @example
     * CommonUtils.Utils.parseUrl("http://me@example.com:80");
     * // will return {"source":"http://me@example.com:80","protocol":"http","authority":"me@example.com:80","domain":"me@example.com","port":"80",...}
     *
     * @param {String} sourceUri - A valid url (e.g. "http://netvibes.com")
     * @return {Object} Object with following properties: source, protocol, authority, domain, port, path, directoryPath, fileName, query, anchor.
     *
     * @alias CommonUtils.Utils.parseUrl
     */
    static parseUrl(sourceUri) {
        var uriPartNames = ['source', 'subprotocol', 'protocol', 'authority', 'user', 'password', 'domain', 'port', 'path', 'directoryPath', 'fileName', 'query', 'anchor'], uriPartRegExp = new RegExp("^" +
            "(?:(?:(?:([^#.:]+):)?([^#.:]+):)?//)?" + // subprotocol / protocol
            "((?:([^:/]+)(?::([^/]*?))?@)?" + // authority (user / password /
            "([^:/?#]*)(?::(\\d*))?)?" + // domain / port)
            "((/(?:[^?#](?![^?#/]*\\.[^?#/.]+(?:[\\?#]|$)))*/?)?([^?#/]*))?" + // path (directoryPath / fileName)
            "(?:\\?([^#]*))?" + // query
            "(?:#(.*))?" // anchor
        );
        var i, uriParts = uriPartRegExp.exec(sourceUri), uri = {};
        for (i = 0; i < uriPartNames.length; i++) {
            uri[uriPartNames[i]] = (uriParts[i] || '');
        }
        // Remove subprotocol from source
        if (uri.subprotocol) {
            uri.source = uri.source.substr(uri.subprotocol.length + 1);
        }
        // Default port (as String)
        if (!uri.port) {
            uri.port = uri.protocol === 'https' ? '443' : '80';
        }
        // Always end directoryPath with a trailing backslash if a path was present in the source URI
        // Note that a trailing backslash is NOT automatically inserted within or appended to the "path" key
        if (uri.directoryPath && uri.directoryPath.length > 0) {
            uri.directoryPath = uri.directoryPath.replace(/\/?$/, "/");
        }
        // DNS RFCs says hostnames are case insensitive
        uri.domain = uri.domain.toLocaleLowerCase();
        uri.protocol = uri.protocol.toLocaleLowerCase();
        return uri;
    }
    /**
     * Build an Url to from uri parts (protocol, domain, ...).
     *
     * @example
     * CommonUtils.composeUrl({
     *    protocol: "https",
     *    subprotocol: "feed",
     *    authority: "example.org:8080",
     *    domain: "example.org",
     *    port: "8080",
     *    path: "/mypath/mywidget.html",
     *    directoryPath: "/mypath/",
     *    fileName: "mywidget.html",
     *    query: "lorem=ipsum&hello=world",
     *    anchor: "sit"
     * });
     * // will return "feed:https://example.org:8080/mypath/mywidget.html?lorem=ipsum&hello=world#sit"
     *
     *
     * @param {String} parts - An object with following properties: source, protocol, authority, domain, port, path, directoryPath, fileName, query, anchor
     * @return {String} A valid url (e.g. "http://netvibes.com").
     *
     * @alias CommonUtils.composeUrl
     */
    static composeUrl(parts) {
        var result = '';
        if (parts.protocol) {
            result = parts.protocol + '://';
            if (parts.subprotocol) {
                result = parts.subprotocol + ':' + result;
            }
        }
        if (parts.domain) {
            result += parts.domain;
            if (parts.port &&
                (parts.protocol !== 'http' || parseInt(parts.port, 10) !== 80) &&
                (parts.protocol !== 'https' || parseInt(parts.port, 10) !== 443)) {
                result += ':' + parts.port;
            }
        }
        else if (parts.authority) {
            result += parts.authority;
        }
        if (parts.path) {
            result += parts.path;
        }
        if (parts.query) {
            result += '?' + parts.query;
        }
        if (parts.anchor) {
            result += '#' + parts.anchor;
        }
        return result;
    }
    /**
     * Compare two url to check if their domain, protocol and port match.
     *
     * @example
     * // Following will return `true`
     * CommonUtils.Utils.matchUrl('http://example.com/mypath/index.html', '/mypath/index.html');
     * CommonUtils.Utils.matchUrl('http://example.com/mypath/index.html', 'mypath/index.html');
     * CommonUtils.Utils.matchUrl('http://example.com/mypath/index.html', 'http://example.com/index.html');
     *
     * // Following will return `false`
     * CommonUtils.Utils.matchUrl('http://example.com/mypath/index.html', 'http://example.org/mypath/index.html');
     * CommonUtils.Utils.matchUrl('http://example.com/mypath/index.html', 'https://example.com/mypath/index.html');
     *
     * @param {String} originaUrl - First url to compare
     * @param {String} requestUrl - Second url to compare
     * @return {Boolean} `true` if urls match else `false`.
     *
     * @alias CommonUtils.Utils.matchUrl
     */
    static matchUrl(originaUrl, requestUrl) {
        var originalUrlParts, requestUrlParts, matchUrl = false, originalIsAbsolute = CommonUtils.isAbsoluteUrl(originaUrl), requestIsAbsolute = CommonUtils.isAbsoluteUrl(requestUrl);
        // If both are relative then match
        if (!originalIsAbsolute && !requestIsAbsolute) {
            matchUrl = true;
            // Else process check
        }
        else {
            // If one url is not relative fix it using buildUrl.
            // like that we support "/apps/index.html" and "apps/index.html".
            if (!originalIsAbsolute) {
                originaUrl = CommonUtils.buildUrl(requestUrl, originaUrl);
            }
            else if (!requestIsAbsolute) {
                requestUrl = CommonUtils.buildUrl(originaUrl, requestUrl);
            }
            originalUrlParts = CommonUtils.parseUrl(originaUrl);
            requestUrlParts = CommonUtils.parseUrl(requestUrl);
            matchUrl = ['domain', 'protocol', 'port'].every(function (name) {
                // Pure match
                return originalUrlParts[name] === requestUrlParts[name] ||
                    // Protocol less match
                    (name === 'protocol' && (originalUrlParts[name] === '' || requestUrlParts[name] === ''));
            });
        }
        return matchUrl;
    }
    /**
     * Test if an URL is absolute.
     *
     * @example
     * CommonUtils.Utils.isAbsoluteUrl('http://foo.com');
     * // will return true
     *
     * CommonUtils.Utils.isAbsoluteUrl('/foo');
     * // will return false
     *
     * @param {String} url - the url to check
     * @return {Boolean} `true` if the URL is absolute.
     *
     * @alias CommonUtils.Utils.isAbsoluteUrl
     */
    static isAbsoluteUrl(url) {
        var re = /^((https?|ftp|file):)?\/\//;
        return re.test(url);
    }
    /**
     * Encode an Object to a url string.
     *
     * @example
     * CommonUtils.Utils.toQueryString({
     *    example: 1,
     *    array: ['hello', 'world'],
     *    object: {key: 'value'}
     * });
     * // will return "example=1&array[0]=hello&array[1]=world"
     *
     * CommonUtils.Utils.toQueryString({
     *    toQueryString: function () {
     *        return 'hello'
     *    }
     * });
     * // will return "hello"
     *
     * @param {Object} myObject - Object to encode
     * @param {Object} base - Sub object to encode
     * @return {String} Encoded string.
     *
     * @alias CommonUtils.Utils.toQueryString
     */
    static toQueryString(myObject, base) {
        var key, value, result, queryString;
        if (CommonUtils.is(myObject, 'string')) {
            queryString = myObject;
        }
        else if (CommonUtils.is(myObject.toQueryString, 'function')) {
            queryString = myObject.toQueryString();
        }
        else {
            queryString = [];
            for (key in myObject) {
                if (myObject.hasOwnProperty(key)) {
                    value = myObject[key];
                    if (base) {
                        key = base + '[' + CommonUtils.capitalize(key) + ']';
                    }
                    if (CommonUtils.is(value)) {
                        if (CommonUtils.is(value, 'object') || CommonUtils.is(value, 'array')) {
                            result = CommonUtils.toQueryString(value, key);
                        }
                        else if (!CommonUtils.is(value, 'function')) {
                            result = CommonUtils.encodeUrl(key) + '=' + CommonUtils.encodeUrl(value);
                        }
                    }
                    if (result) {
                        queryString.push(result);
                    }
                    // Reset buffer
                    result = undefined;
                }
            }
            queryString = queryString.join('&');
        }
        return queryString;
    }
    static is(object, type) {
        // console.log("DEBUG check object", typeof object, type)
        if (object && type)
            return typeof object === type;
        else if (object)
            return typeof object !== 'undefined';
        else
            return false;
    }
    /**
     * Simple encodeURIComponent wrapper to escape "." to "%2e" also.
     *
     * @example
     * CommonUtils.Utils.encodeUrl("hello?/e;&.");
     * // will return "hello%3F%2Fe%3B%26%2e"
     *
     * @param {String} str - String to encode
     * @return {String} Encoded string.
     *
     * @alias CommonUtils.Utils.encodeUrl
     */
    static encodeUrl(str) {
        return encodeURIComponent(str).replace(/\./g, '%2e');
    }
    static capitalize(str, delimiter = '-') {
        const words = str.split(delimiter);
        for (let i = 0; i < words.length; i++) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        return words.join(delimiter);
    }
}
export default CommonUtils;
//# sourceMappingURL=common-utils.js.map